/**
 * SplashScreen
 */
import React from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';

export class SplashScreen extends React.PureComponent<*> {
    render() {
        return (
            <Dimmer active page style={{ backgroundColor: 'rgb(22, 30, 45)' }}>
                <Loader inline inverted />
            </Dimmer>
        );
    }
}

export default SplashScreen;
